<template>
  <div v-if="error.message" class="error">
    <v-alert prominent type="error" color="red lighten-2">
      <v-row align="center">
        <v-col class="grow headline white--text">
          {{ error.message }}
        </v-col>
        <v-col class="shrink">
          <v-btn
            v-show="error.allowRefresh"
            color="error"
            class="white--text"
            small
            outlined
            @click="reloadApp()"
            >Refresh</v-btn
          >
        </v-col>
        <v-col class="shrink">
          <button
            v-show="error.allowClose"
            type="button"
            class="close"
            aria-label="Close"
            @click="closeError()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    error: {},
  },
  data() {
    return {
      errorMessage: "",
      allowClose: true,
      allowRefresh: true,
    };
  },
  methods: {
    reloadApp() {
      this.$emit("refresh");
    },
    closeError() {
      this.$emit("close");
    },
  },
  computed: {},
  //   watch: {
  //     error(newValue, oldValue) {
  //       if (newValue !== oldValue) {
  //         this.errorMessage = newValue.message;
  //         this.allowClose = newValue.allowClose;
  //         this.allowRefresh = newValue.allowRefresh;
  //       }
  //     },
  //   },
};
</script>

<style scoped>
.error {
  max-height: 80px !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.v-btn {
  border-color: white !important;
}

.white--text /deep/ span {
  color: white !important;
}

.close {
  color: white !important;
  font-size: 32px !important;
}
</style>
